import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, Grid } from "@material-ui/core";
import robot from "@assets/gears_bot.png";

interface Props {
  text: string;
}

const useStyles = makeStyles({
  container: {
    flexDirection: "column",
    flexGrow: 1,
  },
  text: {
    maxWidth: "250px",
    margin: "0 auto",
  },
  robot: {
    maxWidth: "250px",
  },
  bubble: {
    position: "relative",
    background: "white",
  },
  bubble2: {
    content: "",
    position: "absolute",
    bottom: 0,
    left: "50%",
    width: 0,
    height: 0,
    border: "20px solid transparent",
    borderTopColor: "white",
    borderBottom: 0,
    marginLeft: "-10px",
    marginBottom: "-10px",
  },
});

export const BubbleRobot: React.FC<Props> = ({ text }) => {
  const classNames = useStyles();

  return (
    <Box className={classNames.container}>
      <Grid container direction="row" justify="center" alignItems="flex-end">
        <Grid item>
          <Box className={classNames.bubble} p={2}>
            <Typography variant="body1" color="textPrimary" paragraph>
              {text}
            </Typography>
            <div className={classNames.bubble2}></div>
          </Box>
        </Grid>
        <Grid item>
          <Box className={classNames.robot} mt={6}>
            <img src={robot} alt="robot" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
